const AVATAR_SIZE = 52;

const getColumnSize = (percent: number, totalWidth?: number) => {
  if (!totalWidth) {
    return undefined;
  }
  return (totalWidth - AVATAR_SIZE) * percent;
};

export const getColumns = ({ totalWidth }: { totalWidth?: number }) => [
  {
    accessorKey: 'avatar',
    size: AVATAR_SIZE,
    isAvatar: true,
  },
  {
    accessorKey: 'displayName',
    minSize: 62,
    sx: { pl: 0 },
    size: getColumnSize(1, totalWidth),
    enableResizing: true,
  },
  {
    accessorKey: 'gap',
    size: 0,
  },
];
